const resumo_entrega_material_escolar = [
  {
    path: "/resumo-entrega-material-escolar",
    redirect: "/resumo_entrega_material_escolar",
    meta: {
      breadCrumb: "Gestão - Material Escolar",
    },
    children: [
      {
        path: "/resumo-entrega-material-escolar",
        name: "resumo_entrega_material_escolar",
        component: () =>
          import(
            "@/views/ResumoEntregaMaterialEscolar/ResumoEntregaMaterialEscolar.vue"
          ),
      },
    ],
  },
];

export { resumo_entrega_material_escolar };
